// extracted by mini-css-extract-plugin
module.exports = {"card":"content-page_card__PqqoC typography_bodyFont__2-Mbk","section":"content-page_section__Cw2e7","heading":"content-page_heading__1rI36"};